<section class="layout-360">
    <img loading="lazy" class="one" src="./assets/img/gennius/image-one-world.webp">
    <div id="panoramaContainer"></div>
    <button (click)="pre()" *ngIf="!sole">Pre-register</button>
    <span class="icon-arrow" (click)="scrollNext()"></span>
    <app-connect></app-connect>
</section>
<div class="next"></div>
<!-- <section class="cymi-token">
    <div class="container">
        <div class="row">
            <div class="left">
                <img loading="lazy" src="./assets/img/imagine/cymi-token-logo.webp" class="cymi-token-logo">
            </div>
            <div class="right">
                <h2>GMIX token</h2>
                <span class="text-gradient">We are establishing a <br> global hub for GMIX</span>
                <p>GMIX is a token that offers interoperability and instant swaps between loyalty programs, fiat currencies, and the crypto market, allowing users to pay for everyday essentials at over <span>100 million merchants around the world,</span> as well as for <span>NFTs</span> and purchases in the <span>Web3.</span>
                </p>
            </div>
        </div>

        <img loading="lazy" *ngIf="!itsMobile" class="element element-3" src="./assets/img/gennius/cymi/element-3.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        <img loading="lazy" *ngIf="!itsMobile" class="element element-4" src="./assets/img/gennius/cymi/element-4.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
    </div>
    <img loading="lazy" *igIf="!itsMobile" src="./assets/img/gennius/cymi-token-element1.webp" class="cymi-token-element1">
</section> -->


<section class="register" [ngClass]="{'visible': register}">
    <div class="container">
        <div class="gennius__bloque">
            <div class="gennius__left">
                <button class="btn-gennius" (click)="openVideo('14')">Watch video</button>
                <h1>🌐🎶 {{ 'experiment' | translate }}</h1>

                <p>{{'embark' | translate }}</p>

                <h1 class="dos">{{'transform' | translate}}</h1>
            </div>
            <div class="gennius__right">
                <iframe src="https://gennius.xyz/assets/form/form-soledad.html" frameborder="0" width="100%" height="500px"></iframe>
                <!-- <iframe src="http://localhost:8100/assets/form/form-soledad.html" frameborder="0" width="100%" height="500px"></iframe>  -->
            </div>
        </div>
    </div>
</section>



<!-- <section class="register" [ngClass]="{'visible': register}">
    <div class="container">
        <div class="gennius__bloque">
            <div class="gennius__left">
                <h1>🌐🎶 Experience 'Sole as One' — A Dubai real and virtual Integration!</h1>

                <p>Embark on an unprecedented journey with Soledad as we pioneer a new era of musical connection. 'Sole as One' seamlessly blends Dubai's digital innovative spirit with the limitless possibilities of the real and virtual world, fostering a digital community where every interaction is an opportunity for unity and emotional resonance.</p>

                <h1 class="dos">Step into this transformative world. Pre-register now to shape the future of music and connection!</h1>
            </div>
            <div class="gennius__right">
                <iframe src="https://gennius.xyz/demo/assets/form/form-soledad.html" frameborder="0" width="100%" height="500px"></iframe>
                <-- <iframe src="http://localhost:8100/assets/form/form-soledad.html" frameborder="0" width="100%" height="500px"></iframe> --
            </div>
        </div>
    </div>
</section> -->


<section class="sole-one" [ngClass]="{'visible': sole}">
    <div class="container">
        <button class="btn-gennius" (click)="openVideo('14')">Watch video</button>
        <h1>🌐🎶{{'experiment' | translate }}</h1>
        <p >{{'embark' | translate }}</p>
        <!-- <h1 *ngIf="storage" class="dos">¡Entra en este mundo transformador! ¡Preinscríbete ahora para dar forma al futuro de la música y la conexión!</h1> -->
        <div class="imagen-poster" (click)="openVideo('13')">
            <img src="./assets/img/imagine/bg-videos.png" alt="">
            <div class="video-play"></div>
        </div>
        <!-- <video class="video-sole" preload="metadata" controls poster="./assets/img/posters/post-twao.png">
            <source src-tmp="https://imagineas.one/videos/06-soledad.mp4" type="video/mp4">
        </video> -->
    </div>
</section>


<section class="one-world">
    <img loading="lazy" *igIf="!itsMobile" class="one-world-element" src="./assets/img/gennius/one-world-element.webp">
    <div class="container">
        <div class="row">
            <div class="left">
                <img loading="lazy" src="./assets/img/gennius/image-one-world.webp"
                    class="gennius__img gennius__img--layout">

            </div>
            <div class="right">
                <p>We are thrilled to introduce “The World as One” a <span>Motion Life Metaverse Platform</span>.
                    Inspired by John Lennon's vision of global unity, Gennius XYZ and Seed Group will launch a metaverse
                    platform that combines business, community, art, and music.</p>
            </div>
        </div>
        <div class="block block--one">
            <p>This platform will provide users with a seamless, transactional virtual experience for <span>cyber
                    banking</span> services.</p>
        </div>
        <div class="block block--two">
            <p>Engage the virtual community in an immersive experience, and utilize <span>GMIX</span> as the primary
                means of transaction. </p>
        </div>
        <div class="block block--three">
            <p>Experience our '<span>Imagine as One</span>' platform like never before with Apple Vision Pro readiness.
                Dive into different dimensions with enhanced reality, seamlessly integrating all features of our app.
            </p>
        </div>
        <img *ngIf="!itsMobile" class="metaverse-person" src="./assets/img/imagine/metaverse-person.webp"
            ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1'
            [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

        <img *ngIf="!itsMobile" class="metaverse-element metaverse-element--one"
            src="./assets/img/gennius/metaverse-element1.webp" ngxParallaxScroll [config]="ngParallaxConf"
            [parallaxSpeed]='0.5' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"'
            [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        <img *ngIf="!itsMobile" class="metaverse-element metaverse-element--two"
            src="./assets/img/gennius/metaverse-element2.webp" ngxParallaxScroll [config]="ngParallaxConf"
            [parallaxSpeed]='0.4' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"'
            [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        <img *ngIf="!itsMobile" class="metaverse-element metaverse-element--three"
            src="./assets/img/gennius/metaverse-element3.webp" ngxParallaxScroll [config]="ngParallaxConf"
            [parallaxSpeed]='0.3' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"'
            [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        <button class="btn-gennius" (click)="openVideo('12')">Watch video</button>
    </div>
</section>

<section class="studio">
    <span class="icon-arrow" (click)="scrollUp()"></span>
    <div id="panoramaContainer2"></div>
</section>


<div class="bg-videos bg-video--one video-sole" [ngClass]="{'open': video13}">
    <div class="gif-rotate">
        <img src="./assets/img/posters/rotate.gif" alt="">
    </div>
    <div class="icon-close" (click)="closeVideo('13')"></div>

    <video preload="none" class="video-soledad" (ended)="videoEnd('13')" oncontextmenu="return false;" controls controlsList="nodownload" playsinline=""
        poster="./assets/img/posters/poster-sole.png">
        <source src="https://player.vimeo.com/progressive_redirect/playback/957393275/rendition/540p/file.mp4?loc=external&log_user=0&signature=1a99e794760696068ab56118726240ee0b71ea92ee0f1c4a86d850042f628c58" type="video/mp4">
    </video>
</div>

<!-- <section class="futuristic">
    <section class="masterplan">
        <div class="container">
            <h2>A futuristic <br> masterplan</h2>
            <img class="masterplan-building" src="./assets/img/gennius/masterplan-building.webp">

            <div class="block block--one">
                <p><span>Burj Khalifa</span> <br> for private events: <br> Main lobby, offices and <br> conference rooms</p>
            </div>
            <div class="block block--two">
                <p><span>Private areas </span> of the experience will be host,<br> luxury spaces, wide perspectives, the use of <br> banner screens and technology.</p>
            </div>
            <div class="block block--three">
                <p><span>Walkable places</span> <br> Plazas and promenades <br> Green parks <br> Water features <br> NFT Galleries</p>
            </div>

            <img *ngIf="!itsMobile"  class="masterplan-bubble masterplan-bubble--one" src="./assets/img/gennius/masterplan-bubble1.webp" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.3' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img *ngIf="!itsMobile"  class="masterplan-bubble masterplan-bubble--two" src="./assets/img/gennius/masterplan-bubble2.webp" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.6' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img *ngIf="!itsMobile" class="masterplan-bubble masterplan-bubble--three" src="./assets/img/gennius/masterplan-bubble3.webp" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.9' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

        </div>
    </section>

    <section class="arena">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left">
                    <img loading="lazy" *ngIf="!itsMobile" class="masterplan-building" src="./assets/img/gennius/arena.webp">
                    <img loading="lazy" *ngIf="itsMobile" class="masterplan-building" src="./assets/img/gennius/mobile/arena.webp">
                </div>
                <div class="gennius__right">
                    <h2>Arena</h2>
                    <p>A central spine that <br> dematerialises and forms the <br> stands of the stadium</p>
                </div>
            </div>
        </div>
    </section>

    <section class="skyscraper">
        <div class="container">
            <h2>Skyscraper</h2>
            <p>The futuristic microverse will <br> include low poly 3D skyscraper <br> models around the perimeter of <br> the project so we can give the <br> user the feeling of being in a <br> crowded futuristic city.</p>
            <img *ngIf="!itsMobile" class="skyscraper-building" src="./assets/img/gennius/skyscraper-building.webp">
            <img loading="lazy" *ngIf="itsMobile" class="masterplan-building" src="./assets/img/gennius/mobile/skyscraper-building.webp">

            <img *ngIf="!itsMobile" class="skyscraper-bubble skyscraper-bubble--one" src="./assets/img/gennius/skyscraper-bubble1.webp" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.6' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" *ngIf="!itsMobile" class="skyscraper-bubble skyscraper-bubble--two" src="./assets/img/gennius/skyscraper-bubble2.webp" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.3' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>
    </section>
    <app-cymi-world (numberEmiter)="openVideo($event)"></app-cymi-world>
</section>

<section class="page-cymi">


    <section class="second">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left">
                    <img loading="lazy" class="phone-metaverse" src="./assets/img/imagine/phone-metaverse.webp">

                    <img loading="lazy" class="metaverse-element1" src="./assets/img/gennius/metaverse-elementX.webp">
                </div>
                <div class="gennius__right gennius__right--cero">
                    <h2>The metaverse is yours, too!</h2>
                    <p>Search, find and buy lands, avatars or anything in the metaverse.</p>
                </div>
            </div>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-3" src="./assets/img/gennius/cymi/element-3.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>
    </section>

    <section class="third">
        <h2>Imagine all of what you <br> own coming together as one.</h2>
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left">
                    <img loading="lazy" class="shop-woman" src="./assets/img/cryptmi/say-hello3.png">
                </div>
                <div class="gennius__right gennius__right--cero">
                    <h2>Shop and redeem in app and in store worldwide.</h2>
                    <p>Split your payment to combine rewards, debit/credit cards, crypto, and pay in installments.</p>
                </div>
            </div>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-4" src="./assets/img/gennius/cymi/element-4.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>
    </section>

    <section class="gennius--intro" id="intro-cymi">
        <div class="content">
            <h1>A token like no other</h1>
            <img loading="lazy" class="img-cymi" src="./assets/img/imagine/logo-cymi2.webp" alt="gennius">
            <span class="text">Our proprietary token, GMIX, is a cryptoasset that runs on the Polygon blockchain, offering interoperability between loyalty programs, fiat currencies and the crypto market.</span>
            <button class="btn-gennius" (click)="openVideo('1')">Watch video</button>
        </div>
    </section>

    <app-animation-logo class="al"></app-animation-logo>

    <section class="one logo-cymi-aos" id="one">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left">
                    <h1>Connect all your loyalty programs</h1>
                    <p>GMIX consolidates the entire digital asset ecosystem by allowing users to manage a wide array of financial instruments—including rewards programs, credit cards, debit cards, bank accounts, and cryptocurrencies—through a single interface.</p>
                    <button class="btn-gennius" (click)="openVideo('2')">Watch video</button>
                </div>
                <div class="gennius__right gennius__right--cero">
                    <img loading="lazy" class="iphone" src="./assets/img/gennius/cymi/image-1.webp" alt="gennius">
                    <img loading="lazy" class="graphic-1" src="./assets/img/gennius/cymi/graphic-1.webp" alt="gennius">
                    <img loading="lazy" class="graphic-2" src="./assets/img/gennius/cymi/graphic-2.webp" alt="gennius">
                    <img loading="lazy" class="graphic-3" src="./assets/img/gennius/cymi/graphic-3.webp" alt="gennius">
                    <img loading="lazy" class="logo-1" src="./assets/img/imagine/logo-cymi2.webp" alt="gennius">
                </div>
            </div>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-2" src="./assets/img/gennius/cymi/gif/cubo-5.gif" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>


            <img loading="lazy" *ngIf="!itsMobile" class="element element-4" src="./assets/img/gennius/cymi/element-4.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.2' [parallaxSmoothness]='1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>


            <img loading="lazy" *ngIf="!itsMobile" class="element element-14-gif" src="./assets/img/gennius/cymi/element-4.gif" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

        </div>
    </section>
    <section class="inverse-mobile two logo-cymi-aos" id="two">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left gennius__left--cero">
                    <img loading="lazy" class="graphic-1" src="./assets/img/gennius/cymi/graphic-4.webp" alt="gennius">
                    <img loading="lazy" class="graphic-2" src="./assets/img/gennius/cymi/graphic-5.webp" alt="gennius">
                    <img loading="lazy" class="graphic-3" src="./assets/img/gennius/cymi/graphic-6.webp" alt="gennius">
                    <img loading="lazy" class="logo-1" src="./assets/img/imagine/logo-cymi2.webp" alt="gennius">
                </div>
                <div class="gennius__right gennius__right">
                    <h1>Super connected. Fully interoperable.</h1>
                    <p>GMIX is connected to over 11,000 banks and Buy Now Pay Later platforms, enabling settlements in more than 180 global currencies.</p>
                    <button class="btn-gennius" (click)="openVideo('3')">Watch video</button>
                </div>
            </div>


            <img loading="lazy" *ngIf="!itsMobile" class="element element-5" src="./assets/img/gennius/cymi/gif/cubo-5.gif" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='1' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>



            <img loading="lazy" *ngIf="!itsMobile" class="element element-15" src="./assets/img/gennius/cymi/element-14.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

        </div>
    </section>
    <section class="three logo-cymi-aos" id="three">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left">
                    <h1>Over 1,800 cryptocurrencies<br> to choose from</h1>
                    <p>Switch your rewards to over 1,800 cryptocurrencies, and switch and swap between cryptocurrencies and loyalty points.</p>
                    <button class="btn-gennius" (click)="openVideo('4')">Watch video</button>

                </div>
                <div class="gennius__right gennius__right--cero">
                    <img loading="lazy" class="graphic-1" src="./assets/img/gennius/cymi/graphic-7.webp" alt="gennius">
                    <img loading="lazy" class="graphic-2" src="./assets/img/gennius/cymi/graphic-8.webp" alt="gennius">
                    <img loading="lazy" class="graphic-3" src="./assets/img/gennius/cymi/graphic-9.webp" alt="gennius">
                    <img loading="lazy" class="logo-1" src="./assets/img/imagine/logo-cymi2.webp" alt="gennius">
                </div>
            </div>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-7" src="./assets/img/gennius/cymi/gif/cubo-1.gif" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='1' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-8" src="./assets/img/gennius/cymi/element-8.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='1' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-9" src="./assets/img/gennius/cymi/element-9.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.1' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>

    </section>
    <section class="inverse-mobile four logo-cymi-aos" id="four">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left">
                    <img loading="lazy" class="iphone" src="./assets/img/imagine/imagine-8.webp" alt="gennius">
                    <img loading="lazy" class="card" src="./assets/img/gennius/cymi/image-9.webp" alt="gennius">
                    <img loading="lazy" class="graphic-1" src="./assets/img/gennius/cymi/graphic-10.webp" alt="gennius">
                    <img loading="lazy" class="graphic-2" src="./assets/img/gennius/cymi/graphic-11.webp" alt="gennius">
                    <img loading="lazy" class="graphic-3" src="./assets/img/gennius/cymi/graphic-12.webp" alt="gennius">
                    <img loading="lazy" class="logo-1" src="./assets/img/imagine/logo-cymi2.webp" alt="gennius">
                </div>
                <div class="gennius__right gennius__right--cero">
                    <h1>Imagine Digital Card, the first card of its kind</h1>
                    <p>Redeem your rewards using the Imagine Digital Card at over 100 million merchants around the world.</p>
                    <button class="btn-gennius" (click)="openVideo('5')">Watch video</button>
                </div>
            </div>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-16" src="./assets/img/gennius/cymi/gif/cubo-1.gif" alt="gennius" ngxParallaxScroll
            [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"'
            [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-12" src="./assets/img/gennius/cymi/element-11.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-17" src="./assets/img/gennius/cymi/element-14.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>


    </section>
    <section class="five logo-cymi-aos" id="five">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left">
                    <h1>A wide world of travel deals and benefits</h1>
                    <p>Access millions of travel deals at preferential rates and exclusive benefits in Expedia and partner airlines, as well as thousands of merchants.</p>
                    <button class="btn-gennius" (click)="openVideo('6')">Watch video</button>

                </div>
                <div class="gennius__right gennius__right--padding">
                    <img loading="lazy" class="iphone" src="./assets/img/imagine/imagine-7.webp" alt="gennius">
                    <img loading="lazy" class="graphic-1" src="./assets/img/gennius/cymi/graphic-13.webp" alt="gennius">
                    <img loading="lazy" class="graphic-2" src="./assets/img/gennius/cymi/graphic-14.webp" alt="gennius">
                    <img loading="lazy" class="logo-1" src="./assets/img/imagine/logo-cymi2.webp" alt="gennius">
                </div>
            </div>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-10" src="./assets/img/gennius/cymi/element-10.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" *ngIf="!itsMobile" class="element element-11" src="./assets/img/gennius/cymi/element-11.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-18" src="./assets/img/gennius/cymi/gif/element-7.gif" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-19" src="./assets/img/gennius/cymi/element-3.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
        </div>

    </section>
    <section class="inverse-mobile six logo-cymi-aos" id="six">
        <div class="container">
            <div class="gennius__bloque">
                <div class="gennius__left gennius__left--padding">
                    <img loading="lazy" class="graphic-1" src="./assets/img/gennius/cymi/graphic-15.webp" alt="gennius">
                    <img loading="lazy" class="graphic-2" src="./assets/img/gennius/cymi/graphic-16.webp" alt="gennius">
                    <img loading="lazy" class="logo-1" src="./assets/img/imagine/logo-cymi2.webp" alt="gennius">
                </div>
                <div class="gennius__right gennius__right--cero">
                    <h1>A super network of banks and digital sources</h1>
                    <p>The major e-wallets also play a critical role in ensuring interoperability. Apple Pay, Google Pay, and PayPal are among the capabilities incorporated to facilitate rewards transfer onto the system.</p>
                    <button class="btn-gennius" (click)="openVideo('7')">Watch video</button>
                </div>
            </div>
            <img loading="lazy" class="element element-20" *ngIf="!itsMobile" src="./assets/img/gennius/cymi/element-14.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>
            <img loading="lazy" class="element element-21" *ngIf="!itsMobile" src="./assets/img/gennius/cymi/element-3.webp" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='0.2' [parallaxDirection]='"reverse"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

            <img loading="lazy" *ngIf="!itsMobile" class="element element-22" src="./assets/img/gennius/cymi/gif/cubo-5.gif" alt="gennius" ngxParallaxScroll [config]="ngParallaxConf" [parallaxSpeed]='0.1' [parallaxSmoothness]='1' [parallaxDirection]='"straight"' [parallaxTimingFunction]='"linear"' [parallaxThrottleTime]='0'>

        </div>
    </section>

</section>

<div class="bg-video bg-video--gradient" [ngClass]="{'open': video2}">
    <div class="modal-1 container-modal">
        <div class="modal-gradient">
            <video *ngIf="video2" class="main-video" preload="metadata" poster="./assets/img/gennius/cymi/video/poster-video.webp" playsinline autoplay="">
                <source src-tmp="https://player.vimeo.com/progressive_redirect/playback/805703386/rendition/540p/file.mp4?loc=external&signature=6564b7f91a66578d6b957976608a93ffb1f11edd9f6ed9fae9a6cab0bb1caf29" type="video/mp4">
            </video>
        </div>
        <span class="icon-close" (click)="closeVideo('2')"></span>
    </div>


</div> -->

<div class="bg-video" [ngClass]="{'open': video12}">
    <div class="modal-general videointro">
        <div class="gif-rotate" style="display: none;">
            <img src="./assets/img/posters/rotate.gif" alt="">
        </div>
        <video *ngIf="video12" class="main-intro4" autoplay="" oncanplay="this.play()" preload="metadata" controls controlsList="nodownload" (ended)="videoEnd('12')" poster="./assets/img/posters/post-vision.png" playsinline="">
            <source src-tmp="https://imagineas.one/imagine/assets/videos/video-visionpro.mp4" type="video/mp4">
        </video>
        <span class="icon-close" (click)="closeVideo('12')"></span>
    </div>
</div>
<div class="bg-video" [ngClass]="{'open': video14}">
    <div class="modal-general videointro">
        <div class="gif-rotate" style="display: none;">
            <img src="./assets/img/posters/rotate.gif" alt="">
        </div>
        <video *ngIf="video14" class="main-intro5" autoplay="" oncanplay="this.play()" preload="metadata" controls controlsList="nodownload" (ended)="videoEnd('14')" poster="./assets/img/posters/post-twao.png" playsinline="">
            <source src-tmp="https://imagineas.one/imagine/assets/videos/video-twao.mp4" type="video/mp4">
        </video>
        <span class="icon-close" (click)="closeVideo('14')"></span>
    </div>
</div>
<app-footer></app-footer>